import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalVariadoComponent } from 'src/app/shared/modal-variado/modal-variado.component';
import { ModalTitulosEnum } from './modal.titulos.enum';

@Injectable({
  providedIn: 'root'
})
export class ModalVariadoService {
  public icono: string;
  public titulo: string;
  public textoDescriptivo: string;
  public esModalProceso: boolean;

  constructor(public dialog: MatDialog) {}

  modalConfirmacion(textoDescriptivo): MatDialogRef<ModalVariadoComponent> {
    this.icono = './assets/icons/icon-exitosa.svg';
    this.titulo = ModalTitulosEnum.ConsultaExitosa;
    this.esModalProceso = false;

    const config = new MatDialogConfig();
    config.data = {
      icono: this.icono,
      titulo: this.titulo,
      textoDescriptivo,
      esModalProceso: this.esModalProceso,
      botones: { enviar: "Aceptar" },
      role: 'alertdialog'
    };

    return this.dialog.open(ModalVariadoComponent, config); // ✅ retornamos el modal
  }

  modalAlerta(textoDescriptivo): MatDialogRef<ModalVariadoComponent> {
    this.icono = "./assets/icons/warning-yellow.svg";
    this.titulo = ModalTitulosEnum.Importante;
    this.esModalProceso = false;

    const config = new MatDialogConfig();
    config.data = {
      icono: this.icono,
      titulo: this.titulo,
      textoDescriptivo,
      esModalProceso: this.esModalProceso,
      botones: { enviar: "Aceptar" },
      role: "alertdialog"
    };

    return this.dialog.open(ModalVariadoComponent, config); // ✅ retornamos el modal
  }

  modalError(textoDescriptivo, titulo?: ModalTitulosEnum): MatDialogRef<ModalVariadoComponent> {
    this.icono = './assets/icons/icon-no-exitosa.svg';
    this.titulo = titulo ?? ModalTitulosEnum.ConsultaSinExito;
    this.esModalProceso = false;

    const config = new MatDialogConfig();
    config.data = {
      icono: this.icono,
      titulo: this.titulo,
      textoDescriptivo,
      esModalProceso: this.esModalProceso,
      botones: { enviar: "Aceptar" },
      role: 'alertdialog'
    };

    return this.dialog.open(ModalVariadoComponent, config); // ✅ retornamos el modal
  }

  ModalProceso(textoDescriptivo): MatDialogRef<ModalVariadoComponent> {
    this.icono = '';
    this.titulo = ModalTitulosEnum.UnMomentoPorFavor;
    this.esModalProceso = true;

    const config = new MatDialogConfig();
    config.data = {
      icono: this.icono,
      titulo: this.titulo,
      textoDescriptivo,
      esModalProceso: this.esModalProceso,
      botones: null, // Sin botones para proceso
      role: 'alertdialog'
    };

    return this.dialog.open(ModalVariadoComponent, config);
  }
}
